<template>
  <div>
    <div class="search-result">
      <p>
        {{ $t('search.searchResultBefore') }}
        <span class="search-result__item-name">{{ tagName }}</span>
        {{ $t('search.searchResultAfter') }}
      </p>
    </div>
    <menu-list
      style="margin-top: 10px; height: 100% !important; overflow: hidden"
      :items="itemList"
      :column="2"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import MenuList from '@/components/menuList/MenuList'
export default {
  components: {
    MenuList,
  },
  props: {
    tagName: String,
  },
  computed: {
    ...mapGetters({
      getItemByItemCode: 'menu/getItemByItemCode',
      getItemCodesByTagName: 'search/getItemCodesByTagName',
    }),
    itemList() {
      const codes = this.getItemCodesByTagName(this.tagName)
      return codes
        .map((code) => this.getItemByItemCode(code))
        .filter(Boolean)
        .map((item) => ({ ...item, wideView: 0 })) // 検索結果ではワイド表示をつかわない
    },
  },
}
</script>
<style lang="scss" scoped>
.search-result {
  background-color: #fff;
  height: 50px;
  margin-top: 55px;
  &__item-name {
    font-weight: bold;
  }
  p {
    line-height: 50px;
  }
}
</style>
